import { useParams } from "react-router-dom";
import { landingPageConfigs } from "../data/landingPageConfigs";
import { useLandingPageConfig } from "./useLandingPageConfig";

export default function useLandingPageIds(): {
  variantId?: string;
  masterId?: string;
} {
  const { id } = useParams<{ id: string }>();

  const variantId = useLandingPageConfig()?.id;
  const masterId = id ? landingPageConfigs[id]?.id : undefined;

  return {
    variantId,
    masterId,
  };
}
